import { Container } from "react-bootstrap";

export default function Events() {
    return(<Container>
        this is Events page
    </Container>
    )
}